<template>
  <div class="row">
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: auto; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
    />
    <div v-if="!this.$store.getters.isLoading" class="flex xs12">
      <div class="va-card">
        <div class="va-card__header-inner">
          <div class="va-card__header-title" style="color: rgb(44, 130, 224);"> {{ $t('payment.subscribeCompleted') }}</div>
        </div>
        <div class="va-card__body">
          <div v-if="getNeed">
            <h4>{{ $t('payment.thankYouPurchasing') }} - {{ getPackName }} {{ $t('payment.with') }} {{ getPackAmount }} {{ $t('payment.clients') }}</h4>
            <p>
              {{ $t('payment.isActiveUntil') }} {{ untilDate }}, {{ $t('payment.toGetYourInvoice') }} <a href="#" @click="toInvoices">{{ $t('payment.clickHere') }}</a>.
            </p>
            <p>
              {{ $t('payment.dontHesitate') }}
            </p>
            <p style="padding-top: 10px; font-weight: bold;">
              {{ $t('payment.ourMission') }}
            </p>
          </div>
          <div v-if="!getNeed">
            {{ $t('payment.notAnyPayment') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'

export default {
  components: { SwappingSquaresSpinner },
  mixins: [errorHandlerMixin],
  name: 'PaymentCompleted',
  data () {
    return {
      subscriptions: [],
      subscriptionPack: [],
    }
  },
  methods: {
    async toInvoices () {
      await this.$router.push({
        name: 'invoices',
      })
    },
    async initSubscriptions () {
      this.subscriptions.splice(0, this.subscriptions.length, ...this.$store.getters.subscriptions)
    },
    getPacksForSubscription () {
      const packs = this.subscriptions.filter((item) => {
        return item.subscriptionId === this.$store.getters.localUserSubscription.subscriptionId
      })
      this.subscriptionPack = packs[0].subscriptionPacks
    },
  },
  computed: {
    untilDate () {
      if (this.subscriptionPack && this.subscriptionPack.length > 0) {
        const currentDate = new Date()
        const futureDate = new Date(currentDate)
        const period = this.subscriptionPack[0].period
        futureDate.setMonth(currentDate.getMonth() + period)
        return futureDate.toLocaleDateString()
      }
      return ''
    },
    getPackName () {
      if (this.subscriptionPack && this.subscriptionPack.length > 0) {
        return this.subscriptionPack[0].name
      }
      return ''
    },
    getPackAmount () {
      if (this.subscriptionPack && this.subscriptionPack.length > 0) {
        return this.subscriptionPack[0].amount
      }
      return ''
    },
    getNeed () {
      if (this.getPackName && this.getPackAmount && this.untilDate) {
        return true
      }
      return false
    },
  },
  mounted () {
    this.$store.commit('setLoading', true)
    this.$store.dispatch('getSubscriptions')
      .then(() => this.initSubscriptions()).then(() => this.getPacksForSubscription())
      .catch(error => {
        this.errorHandler(error.response)
        this.$store.commit('setLoading', false)
      })
    this.$store.commit('setLoading', false)
  },
}
</script>

<style scoped type="scss">
</style>
